import { c as _c } from "react/compiler-runtime";
import { Box, Flex, Text } from '@chakra-ui/react';
import { ListNavDotIndicator } from '@src/components/sco/Education/ArticleListNav/ListNavDotIndicator';
import { useEducationContext } from '@src/components/sco/Education/EducationContext';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { SSRGate } from '@src/components/sco/utilities/SSRGate';
import { useHover } from '@uidotdev/usehooks';
import React from 'react';
type ArticleListNavCardProps = {
  article?: any;
  id?: string;
  typeSlug?: string;
  slug?: string;
  image?: string;
};
export const ArticleListNavCard = props => {
  const $ = _c(25);
  const educationContext = useEducationContext();
  const [ref, hovering] = useHover();
  const t0 = `url(${props.article.featuredImage?.url || ""}) center center/cover no-repeat`;
  const t1 = educationContext.activeContent.item?.id === props.id ? "colorPalette.solid" : "transparent";
  const t2 = educationContext.activeContent.item?.id === props.id ? "2px solid" : "none";
  const t3 = educationContext.activeContent.item?.id === props.id ? "colorPalette.focusRing" : "transparent";
  const t4 = `/${props.typeSlug || "articles"}/${props.slug}`;
  const t5 = educationContext.activeContent.item?.id === props.id;
  let t6;
  if ($[0] !== props.article.__typename || $[1] !== props.id || $[2] !== t5) {
    t6 = <Box left={0} margin={2} position="absolute" top={0} zIndex={2}><SSRGate disableSSR={true}><ListNavDotIndicator isActive={t5} viewableId={props.id} viewableType={props.article.__typename} /></SSRGate></Box>;
    $[0] = props.article.__typename;
    $[1] = props.id;
    $[2] = t5;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const t7 = hovering ? "saturate(1)" : educationContext.activeContent.item?.id === props.id ? "saturate(1)" : "saturate(0.5)";
  const t8 = hovering ? "colorPalette.container/50" : educationContext.activeContent.item?.id === props.id ? "colorPalette.container/50" : "rgba(24, 23, 39, .5)";
  let t9;
  if ($[4] !== t7 || $[5] !== t8) {
    t9 = <Box bg="linear-gradient(to bottom, transparent, rgba(24, 23, 39, .9))" height="full" left={0} position="absolute" top={0} transition="all 0.2s ease-in" width="full" zIndex={1} backdropFilter={t7} bgColor={t8} />;
    $[4] = t7;
    $[5] = t8;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  const t10 = hovering ? educationContext.activeContent.item?.id === props.id ? "white" : "white" : educationContext.activeContent.item?.id === props.id ? "white" : "actionPrimary";
  let t11;
  if ($[7] !== props.article.title || $[8] !== t10) {
    t11 = <Text as="span" fontWeight={600} lineClamp={2} textStyle="sm" zIndex={3} color={t10}>{props.article.title}</Text>;
    $[7] = props.article.title;
    $[8] = t10;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  let t12;
  if ($[10] !== props.id || $[11] !== t11 || $[12] !== t4 || $[13] !== t6 || $[14] !== t9) {
    t12 = <NextLink key={props.id} href={t4}>{t6}{t9}{t11}</NextLink>;
    $[10] = props.id;
    $[11] = t11;
    $[12] = t4;
    $[13] = t6;
    $[14] = t9;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t0 || $[17] !== t1 || $[18] !== t12 || $[19] !== t2 || $[20] !== t3) {
    t13 = <Flex asChild={true} align="flex-end" aspectRatio={1.7777777777777777} background={t0} bgColor={t1} border={t2} borderRadius="lg" boxShadow="base" justify="flex-start" overflow="hidden" padding={3} position="relative" transition="all 0.2s ease-in" width="full" borderColor={t3}>{t12}</Flex>;
    $[16] = t0;
    $[17] = t1;
    $[18] = t12;
    $[19] = t2;
    $[20] = t3;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== ref || $[23] !== t13) {
    t14 = <Box ref={ref} width="full">{t13}</Box>;
    $[22] = ref;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  return t14;
};